import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import DarkMode from "../Component/DarkMode";
import { Button, Dropdown } from 'react-bootstrap';
import LogoMini from '../Component/Logo-mini';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

const Header = ({ openSidebar }) => {
    const navigate = useNavigate()
    const user = localStorage.getItem("User")
    const role = localStorage.getItem("role")
    const logoutFunc = async () => {
        const token = Cookies.get('fmljwt')
        if (token) {
            toast('Logout Succesfully')
            Cookies.remove('fmljwt')
            localStorage.removeItem("permissions")
            navigate("/")
            document.documentElement.removeAttribute("class");
        } else {
            navigate("/")
        }
    }
    return (
        <>
            <header className="sidebar-header">
                <div className="header-left-menu">
                    <Link to="/" className='d-xl-none'>
                        <LogoMini />
                    </Link>
                </div>
                <div className="header-right-menu">
                    <DarkMode />
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-autoclose-true">
                            <div className="user-menu">
                                <div className="user-img">
                                    <img src="/logo/logomini.svg" alt='RTO Partner' />
                                </div>
                                <div className="user-name ms-2">
                                    <h6>{user}</h6>
                                    <p>{role}</p>
                                </div>
                            </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="dropdown-menu dropdown-menu-end">
                            <Dropdown.Item onClick={logoutFunc}>
                                Logout
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button className="burger-btn d-xl-none" onClick={openSidebar}>
                        <i className='bx bx-menu fs-3'></i>
                    </Button>
                </div>
            </header>
        </>
    )
}

export default Header